import { render } from "./GlobalChat.vue?vue&type=template&id=744e3f49&scoped=true&lang=pug"
import script from "./GlobalChat.vue?vue&type=script&lang=js"
export * from "./GlobalChat.vue?vue&type=script&lang=js"

import "./GlobalChat.vue?vue&type=style&index=0&id=744e3f49&scoped=true&lang=scss"

import exportComponent from "/Users/adolforeyna/Projects/EMI/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744e3f49"]])

export default __exports__